import { HeartPulse } from "lucide-react";
import FloatingTool from "./FloatingTool";

// ClinPulse: ventana modal (reducida en escritorio, completa en móvil). Solo Pro o si el admin lo otorga.
export default function FloatingClinPulse() {
  return (
    <FloatingTool
      src="/clinpulse.html"
      title="ClinPulse · Infusiones pediátricas"
      label="ClinPulse"
      Icon={HeartPulse}
      colorClass="bg-rose-600"
      shadowClass="shadow-rose-600/30"
      bottomClass="bottom-[15rem]"
    />
  );
}
